module.exports = __webpack_public_path__ + "img/Video.e8bd2618.svg";